var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalkSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_walk",
    "data-name": "icon walk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20066",
    "data-name": "Path 20066",
    d: "M9-14.062a1.688,1.688,0,0,1-1.687,1.688,1.688,1.688,0,0,1-1.687-1.687A1.688,1.688,0,0,1,7.313-15.75,1.688,1.688,0,0,1,9-14.062ZM4.447-8.743l-.1.042-.387.172a2.248,2.248,0,0,0-1.177,1.22l-.053.134A1.123,1.123,0,0,1,1.27-6.55,1.126,1.126,0,0,1,.643-8.012L.7-8.146a4.513,4.513,0,0,1,2.351-2.44l.387-.172a5.642,5.642,0,0,1,2.322-.492A3.879,3.879,0,0,1,9.337-8.863l.51,1.294.78.376a1.124,1.124,0,0,1,.5,1.508,1.124,1.124,0,0,1-1.508.5L8.684-5.65a1.694,1.694,0,0,1-.8-.861L7.545-7.32l-.679,2.3,1.74,1.9A1.668,1.668,0,0,1,9-2.384L9.809.851a1.122,1.122,0,0,1-.816,1.364A1.17,1.17,0,0,1,7.6,1.4L6.852-1.7,4.37-4.412a2.169,2.169,0,0,1-.517-2.1l.594-2.232ZM2.416-1.758l.878-2.194a3.368,3.368,0,0,0,.246.3L4.971-2.088,4.461-.816a1.62,1.62,0,0,1-.373.566L1.921,1.92A1.124,1.124,0,1,1,.329.33L2.416-1.758Z",
    transform: "translate(6 19)",
    fill: "#4877ce"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkSelected);
export default __webpack_public_path__ + "static/media/walk-selected.2172cdd2d39b4385bb91e106c8683a39.svg";
export { ForwardRef as ReactComponent };